import { Button, Descriptions, Tree } from "antd";
import React from "react";
import { SaveOutlined, StopOutlined } from '@ant-design/icons';
import * as Icons from '@ant-design/icons';
import { BaseComponent } from "../../components/infrastructure/baseComponent";
import { enmEntityState, ICallOptions } from "../../components/infrastructure/models";
import { IClaim, IRoleClaim, IRoleClaimGetResult, IRoleClaimProps, IRoleClaimStates } from "./interfaces";
import { DataNode } from "antd/lib/tree";
import { Core } from "../../components/infrastructure/core";
import CustomSpinner from "../../components/infrastructure/customSpinner";

export class RoleClaim extends BaseComponent<IRoleClaimProps, IRoleClaimStates>{

    constructor(props: IRoleClaimProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            roleClaims: [],
            claims: [],
            nodes: [],
            expandedKeys: [],
            allowEdit: false,
            checkedKeys: {
                checked: [],
                halfChecked: []
            },
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.loadData();
    }
    async loadData() {
        let roleIds: number[] = [];
        let roleId = this.props.params && this.props.params().role?.Id;
        if (roleId)
            roleIds.push(roleId);
        let opt: ICallOptions = {
            url: 'role/getroleclaims',
            data: { roleIds },
            onSuccess: (result) => {
                if (result.ValidationState.Successful) {
                    let data: IRoleClaimGetResult = (result as any).Data;
                    let nodes: DataNode[] = this.renderClaims(data.Claims);
                    let expandedKeys: React.Key[] = nodes.map(c => c.key);
                    let claims = data.Claims.map(c => (c.ParentName ? c.ParentName + "." : "") + c.Name);
                    let checkedKeys: React.Key[] = data.RoleClaims.filter(r => claims.indexOf(r.Claim) > -1).map(r => r.Claim);
                    checkedKeys.forEach(k => {
                        if (expandedKeys.indexOf(k) === -1)
                            expandedKeys.push(k);
                    });
                    this.setState({
                        loading: false,
                        roleClaims: data.RoleClaims,
                        claims: data.Claims,
                        nodes: nodes,
                        expandedKeys: expandedKeys,
                        allowEdit: data.AllowEdit,
                        checkedKeys: {
                            checked: checkedKeys,
                            halfChecked: []
                        }
                    })
                }
            }
        };
        await this.callApi(opt);
    }
    renderClaims(claims: IClaim[], parentName: string | null = null): DataNode[] {
        let nodes: DataNode[] = [];
        claims.filter(c => c.ParentName === parentName)
            .forEach(c => {
                if (c.Name === "Home" || c.Name === "Portal")
                    return;

                let node: DataNode = {
                    key: (c.ParentName ? c.ParentName + "." : "") + c.Name,
                    title: c.Title,
                    icon: this.getIcon(c.Icon),
                    disableCheckbox: this.props.params && this.props.params().role?.Id === 1 ? true : false
                };
                let children = this.renderClaims(claims, c.Name);
                if (children.length)
                    node.children = children;
                nodes.push(node);
            });
        return nodes;
    }
    getIcon = (name?: string) => {
        const Icon = name ? (Icons as any)[name] : null;
        if (Icon)
            return <Icon />;
    }
    onExpand = (expandedKeysValue: React.Key[]) => {
        this.setState({ expandedKeys: expandedKeysValue });
    }
    onCheck = (checked: React.Key[] | { checked: React.Key[]; halfChecked: React.Key[]; }) => {
        if ((checked as any)?.checked) {
            let checkedKeys = checked as { checked: React.Key[]; halfChecked: React.Key[]; };
            let currentCheckedKeys: React.Key[] = [];
            checkedKeys.checked.forEach(key => {
                let name: string | null = key as string;
                while (name) {
                    let tmp: string | null = name?.split('.')[0];
                    let node = this.state.claims.map(c => { return { ParentName: c.ParentName, Name: c.Name } })
                        .find(c => c.Name === tmp);

                    if (node && checkedKeys.checked.indexOf(node.Name) === -1 && currentCheckedKeys.indexOf(node.Name) === -1) {
                        name = (node.ParentName ? node.ParentName + "." : "") + node.Name;
                        if (name.split('.').length === 1)
                            break;
                        if (currentCheckedKeys.indexOf(name) === -1)
                            currentCheckedKeys.push(name);
                    }
                    else
                        name = null;
                }
                if (currentCheckedKeys.indexOf(key) === -1)
                    currentCheckedKeys.push(key);
            });
            this.setState({
                checkedKeys: { checked: currentCheckedKeys, halfChecked: [] }
            });
        }
    }
    async save() {
        let changes: IRoleClaim[] = [];
        this.state.roleClaims.forEach(item => {
            if (this.state.checkedKeys.checked.indexOf(item.Claim) === -1)
                changes.push({ Id: item.Id, RowGuid: item.RowGuid, RowVrsn: item.RowVrsn, State: enmEntityState.Deleted } as any);
        });
        this.state.checkedKeys.checked.forEach(item => {
            if (this.state.roleClaims.map(i => i.Claim).indexOf(item.toString()) === -1)
                changes.push({ RowGuid: Core.newId(), State: enmEntityState.Added, RoleId: this.props.params && this.props.params().role?.Id, Claim: item.toString() } as any);
        });
        if (changes.length) {
            let opt: ICallOptions = {
                url: 'role/saveroleclaims',
                data: { changes },
                onSuccess: async (result) => {
                    if (result.ValidationState.Successful) {
                        Core.successNotification('تغییرات با موفقیت ذخیره شد');
                        await this.loadData();
                    }
                }
            };
            await this.callApi(opt);
        }
    }
    virtualRender() {

        let extraButtons: React.ReactNode;
        if (this.state.allowEdit && (this.props.params && this.props.params().role?.Id === 1 ? false : true))
            extraButtons = (
                <div key="roleclaims">
                    <Button key="roleclaims-1" type="ghost" onClick={() => {
                        if (this.props.onClose)
                            this.props.onClose(this);
                        else
                            window.history.back();
                    }} icon={<StopOutlined />} style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '100px', marginLeft: 10, background: '#fff' }}>
                        لغو
                    </Button>
                    <Button key="roleclaims-2" style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '100px' }} type="primary" onClick={() => this.save()} icon={<SaveOutlined />} loading={this.state.loading}>
                        ذخیره
                    </Button>
                </div>
            );

        let descriptions: React.ReactNode | undefined =
            this.props.params &&
            (
                <Descriptions className="header-page">
                    <Descriptions.Item label="نام نقش">{this.props.params().role?.Name}</Descriptions.Item>
                    <Descriptions.Item label="عنوان نقش">{this.props.params().role?.Description}</Descriptions.Item>
                </Descriptions>
            );

        const header = this.getPageHeader({
            title: "دسترسی های نقش ها",
            onBack: () => {
                if (this.props.onClose)
                    this.props.onClose(this);
                else
                    window.history.back();
            },
            extraHeaderButtons: extraButtons,
            extraHeaderNodes: descriptions
        });

        return (
            <>
                <div style={{ position: "sticky", top: 0, zIndex: 1 }}>
                    {header}
                </div>
                <div className="box" style={{ marginTop: 10 }} >
                    {this.state.loading
                        ? <div className="center"><CustomSpinner /></div>
                        :
                        <Tree
                            showLine={true}
                            showIcon={true}
                            checkable
                            expandedKeys={this.state.expandedKeys}
                            checkedKeys={this.state.checkedKeys}
                            onExpand={this.onExpand}
                            onCheck={this.onCheck}
                            treeData={this.state.nodes}
                            checkStrictly={true}
                            style={{ margin: 10 }}
                        />}
                </div>
            </>
        );
    }
    resize() {

    }
}